import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-forbidden-dialog',
    templateUrl: './forbidden-dialog.component.html',
    styleUrls: ['./forbidden-dialog.component.sass'],
    standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForbiddenDialogComponent {
  dialogRef = inject(NgbActiveModal);


  onClick() {
    this.dialogRef.close();
  }
}
